export const build = { date:"2026-05-15.1033", stage:"alpha" }
